<template lang='pug'>
  
	div#inspecao(:class="{ 'level-1': grupo && !registro, 'level-2': registro }")


		//- NÍVEL 0 - Ferramentas de inspeção e listagem de grupos de informação encontrados.

		div.float-box-view-level-0
		
			div.col-md-12.float-box-title
				h2.pull-left 
					i.mdi.mdi-information-outline
					| Inspeção

			//- Abas de navegação e ferramentas de inspeção

			div.col-md-12.float-box-title-extras

				hr 

				ul.nav.justify-content-center.nav-icons.row

					li.nav-item.col-4
						a.nav-link(href='#', @click="abrirTela('PONTO')", :class="{ active: tela === 'PONTO' }")
							i.mdi.mdi-crosshairs-gps
							small Ponto

					li.nav-item.col-4
						a.nav-link(href='#', @click="abrirTela('POLIGONO')", :class="{ active: tela === 'POLIGONO' }")
							i.mdi.mdi-vector-square
							small Área

					li.nav-item.col-4
						a.nav-link(href='#', @click="abrirTela('SHAPE')", :class="{ active: tela === 'SHAPE' }")
							i.mdi.mdi-upload
							small Shape

				div(v-show="tela === 'PONTO'")

					inspecao-geometria.ferramenta-inspecao(ref="PONTO", :tipoGeometria="TipoGeometria.PONTO", :maxAreaHA="maxAreaHA")

				div(v-show="tela === 'POLIGONO'")

					inspecao-geometria.ferramenta-inspecao(ref="POLIGONO", :tipoGeometria="TipoGeometria.POLIGONO", :maxAreaHA="maxAreaHA")

				div(v-show="tela === 'SHAPE'")

					inspecao-shape.ferramenta-inspecao(ref="SHAPE", :maxAreaHA="maxAreaHA")

				div.row
					div.col-12
						button.btn.btn-primary.btn-sm.float-right(type="button", @click="inspecionar")
							i.mdi.mdi-magnify
							|  Inspecionar

						button.btn.btn-outline-secondary.btn-sm(type="button", @click="limpar")
							i.mdi.mdi-eraser
							|  Limpar


			div.float-box-default-padding(v-show="showAlert")
				alert(:msg="mensagemErro || ''", :visible="showAlert", type="error")


			//- Listagem de grupos de informação encontrados na pesquisa.

			div.float-box-content

				listagem-grupos-registros(
						ref="listagemGruposRegistros", 
						v-if="pesquisaEfetuada", 
						:grupos="gruposInformacao",
						@exibirGrupo="exibirGrupo")

				empty-result.full-height(message="Nenhuma camada ativa", 
						v-if="!pesquisaEfetuada && (!camadasAtivas || !camadasAtivas.length)")


		//- NÍVEL 1 - Listagem de registros de uma camada, exibido quando o usuário clica 
		//- em um dos grupos listados

		div.float-box-view-level-1

			div.col-md-12.float-box-title(v-if="grupo")
				h2.pull-left()
					i.fa.fa-chevron-left.action-icon(@click="ocultarGrupo()")
					
					span(:title="grupo.camada.nome") {{ grupo.camada.nome }}

			div.col-12.float-box-content-menu.float-box-content-menu-border.d-flex.flex-row-reverse
				
					div.action-link(@click="exportarCSV()")
						span.mdi.mdi-download
						|  Exportar CSV

			div.float-box-content

				listagem-registros.no-first-border(
						ref="listagemRegistros", 
						v-if="paginacaoRegistros && paginacaoRegistros.itens", 
						:registros="paginacaoRegistros.itens",
						@exibirRegistro="exibirRegistro",
						:showMarkers="true")

			div.float-box-footer(v-if="paginacaoRegistros && paginacaoRegistros.itens && paginacaoRegistros.itens.length > 0")
				
				paginacao(ref="paginacaoRegistros", 
						:total="paginacaoRegistros.totalItens", 
						:page-size="paginacaoRegistros.itensPorPagina", 
						:onChange="alterarPaginaRegistros", 
						:options="paginationOptions")


		//- NÍVEL 2 - Visualização dos detalhes de um registro da camada, exibido quando 
		//- o usuário clica em um dos registros na listagem

		div.float-box-view-level-2

			visualizacao-registro-camada(
					:registro="registro", 
					v-if="registro", 
					@close="ocultarRegistro()", 
					:showReturnButton="true")

</template>

<script>

import EmptyResult from '@/components/utils/EmptyResult';
import Alert from '@/components/utils/Alert';
import InspecaoGeometria from './InspecaoGeometria';
import InspecaoShape from './InspecaoShape';
import TipoGeometria from '@/models/tipoGeometria';
import LeafletUtils from '@/utils/leafletUtils';
import camadasService from '@/services/camadasService';
import ListagemRegistros from '@/components/ListagemRegistrosCamada';
import ListagemGruposRegistros from '@/components/ListagemGruposRegistrosCamadas';
import VisualizacaoRegistroCamada from '@/components/VisualizacaoRegistroCamada';
import Paginacao from '@/components/utils/Paginacao';
import Config from '@/config.js';

import filesaver from 'file-saver';

var requestOptions = {
	lockElement: '#inspecao',
	lockMessage: 'Aguarde, buscando informações.'
};

var requestOptionsCSV = {
	lockElement: '#inspecao',
	lockMessage: 'Aguarde, gerando arquivo CSV.'
};

const PAGINA_INICIAL = 1;

export default {

	name: 'Inspecao',

	componentOptions: {
		
		title: 'Inspeção',

		actions: [
			[
				{
					name: 'Inspeção',
					iconClass: 'mdi mdi-information-outline',
					showView: true
				}
			]
		],

		events: {
			'inspecao.show': 'inspecionarPonto'
		}
	},

	components: { EmptyResult, Alert, InspecaoGeometria, InspecaoShape, Paginacao, ListagemRegistros, ListagemGruposRegistros, VisualizacaoRegistroCamada },

	data () {
		return {
			tela: 'PONTO',
			telas: ['SHAPE', 'POLIGONO', 'PONTO'],
			TipoGeometria: TipoGeometria,
			geometria: null,
			layer: null,
			wktExpiration: null,
			maxAreaHA: Config.inspecao.areaLimiteHA,

			wkt: null,
			wktKey: null,
			msgEmptyResult: null,
			mensagemErro: null,
			pesquisaEfetuada: false,
			showAlert: false,
			gruposInformacao: null,
			grupo: null,
			registro: null,
			paginacaoRegistros: {
				itens: []
			},
			paginationOptions: {
				offset: 1,
				previousText: '«',
				nextText: '»',
				alwaysShowPrevNext: true
			}
		};
	},

	methods: {

		/**
		 * Alterna entre as ferramentas de inspeção.
		 */
		abrirTela (tela) {

			if (this.tela === tela) return;

			var componenteAtual = this.$refs[this.tela];
			var componenteNovo = this.$refs[tela];

			if (componenteAtual.removerGeometriasMapa) componenteAtual.removerGeometriasMapa();

			if (componenteNovo.adicionarGeometriasMapa) componenteNovo.adicionarGeometriasMapa();

			this.tela = tela;
		},

		/**
		 * Executa as validações do componente de inspeção selecionado e busca os grupos
		 * de informações.
		 */
		inspecionar () {

			this.showAlert = false;
			this.ocultarRegistro();
			this.ocultarGrupo();
			let tela = this.getTelaAtual();
			let geometria = tela.getGeometria();
			let layer = geometria && geometria.layer;

			this.geometria = tela.getGeometria();

			tela.validar(() => {

				if (layer !== this.layer) {

					this.geometria = geometria;
					this.layer = layer;
					this.wkt = LeafletUtils.layerToWKT(this.layer);
					this.wktKey = null;
					this.wktExpiration = null;
				}

				this.limparOutrasTelas();
				this.buscarGruposInformacoesWkt();
			});
		},

		/**
		 * Método utilizado para inspeção utilizando o botão direito do mouse no mapa.
		 */
		inspecionarPonto (e) {

			this.abrirTela('PONTO');

			this.$refs.PONTO.inspecionarGeometria({
				type: 'Point',
				coordinates: [ e.latlng.lng, e.latlng.lat ]
			});

			this.inspecionar();
		},

		/**
		 * Efetua a busca no servidor pelos grupos de informações referente
		 * às camadas ativas que intersecionam com gemetria vetorizada.
		 */
		buscarGruposInformacoesWkt () {

			this.gruposInformacao = null;
			this.msgEmptyResult = null;

			var params = this.getParametrosWkt();
			params.idsCamadas = _.map(this.camadasAtivas, 'id');

			if (!params.idsCamadas || !params.idsCamadas.length) {

				this.pesquisaEfetuada = false;
				return;
			}

			camadasService.findGrupoInformacoesByWKT(params,
				(result) => {
				
					this.pesquisaEfetuada = true;
					this.gruposInformacao = result.data || [];
					this.wktKey = result.wktKey;
					this.wktExpiration = result.wktExpiration;

				}, this.getRequestErrorHandler('Não foi possível efetuar a pesquisa.'), requestOptions);
		},

		/**
		 * Busca os registros de uma camada (grupo) selecionada na listagem de grupos.
		 */
		buscarInformacoesWktCamada (paginaAtual) {

			if (!this.grupo) return;

			var params = this.getParametrosWkt();
			params.idsCamadas = [ this.grupo.camada.id ];
			params.pagina = paginaAtual || PAGINA_INICIAL;

			camadasService.findInformacoesByWKT(params,
				(result) => {

					this.paginacaoRegistros = result.data;
					this.wktKey = result.wktKey;
					this.wktExpiration = result.wktExpiration;
					
				}, this.getRequestErrorHandler('Não foi possível efetuar a pesquisa.'), requestOptions);
		},

		/**
		 * Retorna objeto contendo qual parâmetro (wkt ou wktKey) deve ser enviado nas requisições.
		 */
		getParametrosWkt () {

			if (this.wktKey && this.wktExpiration && this.wktExpiration > new Date()) {

				return { wktKey: this.wktKey };

			} else {

				return { wkt: this.wkt };
			}
		},

		/**
		 * Acionado quando o usuário clica em um dos ítens da listagem de grupos
		 * de informação, retornados pela pesquisa. Busca os registros da camada
		 * e as exibe.
		 */
		exibirGrupo (e) {

			this.limparPaginacaoRegistros();
			this.grupo = e.grupo;
			this.buscarInformacoesWktCamada();
		},

		/**
		 * Oculta um grupo retornando à listagem de grupos.
		 */
		ocultarGrupo () {

			if (this.$refs.listagemRegistros) this.$refs.listagemRegistros.limpar();
			this.limparPaginacaoRegistros();
			this.grupo = null;
		},

		/**
		 * Limpa as informações referentes à paginação.
		 */
		limparPaginacaoRegistros () {

			if (this.$refs.paginacaoRegistros) this.$refs.paginacaoRegistros.setPage(PAGINA_INICIAL);
			this.paginacaoRegistros = null;
		},

		/**
		 * Método utilizado na paginação de registros de camada para abrir uma pãgina.
		 */
		alterarPaginaRegistros (pagina) {

			this.buscarInformacoesWktCamada(pagina);
		},

		/**
		 * Exibe os detalhes de um registro.
		 */
		exibirRegistro (e) {
			
			this.registro = e.registro;
		},

		/**
		 * Oculta o registro exibido, retornando à listagem de registros de uma camada.
		 */
		ocultarRegistro () {

			this.registro = null;
		},

		/**
		 * Retorna uma função para tratar os erros de requisição.
		 */
		getRequestErrorHandler (defaultMessage) {

			return (result) => {
				this.mensagemErro = result.texto || defaultMessage;
				this.showAlert = true;
			};
		},

		/**
		 * Retorna o componente referente à ferramenta de inspeção selecionada
		 * (shape, polígono e ponto).
		 */
		getTelaAtual () {

			return this.$refs[this.tela];
		},

		/**
		 * Limpa todas as ferramentas de inspeção, exceto a selecionada atualmente.
		 */
		limparOutrasTelas () {

			for (let nomeTela of this.telas) {

				if (nomeTela !== this.tela) {
					
					this.$refs[nomeTela].limpar();
				}
			}
		},

		/**
		 * Limpa todas as ferramentas de inspeção.
		 */
		limpar () {
		
			this.getTelaAtual().limpar();
			this.limparOutrasTelas();
			this.showAlert = false;
		},

		/*
		 * Exportar o resultado da pesquisa em CSV ( Sem paginação )
		 */
		exportarCSV () {

			var params = this.getParametrosWkt();
			params.idsCamadas = [ this.grupo.camada.id ];

			camadasService.exportCSVInformacoesCamadaByWKT(params,
				(result) => {
					
					// Solução temporária, pois o AXIOS ( API de REST utilizada pelo sistema ) não
					// da suporte pra chunked streaming
					let downloadName = 'informacoes-' + this.grupo.camada.nome.toLowerCase() + '-' + this.dataAtualFormatada + '.csv';
					var file = new File([result.data], downloadName, {type: 'text/csv'});
					filesaver.saveAs(file);

				}, this.getRequestErrorHandler('Não foi possível gerar o arquivo CSV.'), requestOptionsCSV);

		},

		// Método chamado pelo componente pai (ToolBox)
		beforeComponentHide () {

			this.limpar();
		}
	},

	computed: {

		camadasAtivas () {
			return this.$store.getters.camadasAtivasSig;
		},
		
		/** Gera a data atual */
		dataAtualFormatada () {

			var data = new Date();
			
			var dia = data.getDate();
			
			if (dia.toString().length === 1) dia = '0' + dia;

			var mes = data.getMonth() + 1;

			if (mes.toString().length === 1) mes = '0' + mes;
			
			var ano = data.getFullYear();
			
			return dia + '-' + mes + '-' + ano;
		}
	}
};

</script>

<style lang="scss" scoped>

@import "../../styles/variaveis";

$filtro-pesquisa-height: 211px;

#inspecao {
	height: 100%;
	
	.float-box-view-level-0 .float-box-content {
		top: $float-box-content-top + $filtro-pesquisa-height;		
	}

	.float-box-view-level-1 .float-box-content {
		bottom: $float-box-footer-height;
		top: $float-box-content-top + $float-box-content-menu-height + 1px;
	}

	.inspecao-geometria {
		padding-bottom: 24px;
	}

	.ferramenta-inspecao {
		height: 96px;
	}
}

</style>



// WEBPACK FOOTER //
// Inspecao.vue?28c55cba